import Bridge from '@/libs/bridge'

export default {

  // 客户端返回极光统计数据
  initCountEvent() {
    Bridge.registerHandler('getDeviceInfo', (data, responseCallback) => {
      data = data.split(',')

      if (data.length > 7) {
        var BrowseEvent = window.JAnalyticsInterface.Event.BrowseEvent;
        var bEvent = new BrowseEvent(data[0], data[1], data[2], parseInt(data[3]));
        bEvent.addKeyValue("用户ID", data[4]).addKeyValue("手机号", data[5]).addKeyValue("手机品牌", data[6]).addKeyValue("客户端类型", data[7]).addKeyValue("手机型号", data[8]).addKeyValue("系统", data[9]);
        window.JAnalyticsInterface.onEvent(bEvent);
      } else {
        // 极光统计
        var CountEvent = window.JAnalyticsInterface.Event.CountEvent;
        var cEvent = new CountEvent(data[0]);
        cEvent.addKeyValue("用户ID", data[1]).addKeyValue("手机号", data[2]).addKeyValue("手机品牌", data[3]).addKeyValue("客户端类型", data[4]).addKeyValue("手机型号", data[5]).addKeyValue("系统", data[6]);
        window.JAnalyticsInterface.onEvent(cEvent);
      }
      responseCallback(data)
    })
  },

  // 客户端返回极光统计数据
  initBrowseEvent(json) {
    // 获取极光统计所需数据
    Bridge.callHandler('getDeviceInfo', json, response => {
      console.log('response:', response)
    })
  },

  text() {
    console.log("测试，测试！！！")
  }
}
